import { Card, DatePicker, Select, Table } from 'antd';
import type { Moment } from 'moment';
import React, { useState } from 'react';
import useSWR from 'swr';

import PageHeader from '@/components/PageHeader';

import {
  getColumns,
  getHistoryUrl,
  historyFetcher,
  optionsFetcher,
} from './helpers';
import styles from './styles.module.scss';

const LockerHistoryPage: React.FC = () => {
  const [selectedLocker, setSelectedLocker] = useState<string | null>(null);
  const [selectedEvent, setSelectedEvent] = useState<string | null>(null);
  const [queryTimes, setQueryTimes] = useState<[Moment, Moment] | null>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortTime, setSortTime] = useState<'ascend' | 'descend'>('ascend');

  const historyUrl = getHistoryUrl({
    selectedLocker,
    selectedEvent,
    queryTimes,
    currentPage,
    sortTime,
  });

  const { data: options } = useSWR(
    '/ezcon/api/ultraLocker/backstageHistoryOptions',
    optionsFetcher
  );
  const { data: history } = useSWR(historyUrl, historyFetcher, {
    refreshInterval: 10000,
  });

  const resetPage = () => setCurrentPage(1);

  const columns = getColumns({
    sortTime,
    setSortTime,
  });

  const lockerOptions = options?.lockers.map((locker) => ({
    label: locker.name,
    value: locker.id,
  }));

  const eventOptions = options?.events.map((event) => ({
    label: event,
    value: event,
  }));

  const dataSource = history?.data.map((item) => ({
    key: item.id,
    ...item,
  }));

  return (
    <div>
      <PageHeader
        title="無人置物櫃歷史紀錄"
        breadcrumbs={[
          {
            name: '郵件包裹',
          },
          {
            name: '無人置物櫃歷史紀錄',
          },
        ]}
      />
      <div className={styles.filters}>
        <div>
          <span>櫃位：</span>
          <Select
            placeholder="請選擇置物櫃編號"
            options={lockerOptions}
            allowClear
            value={selectedLocker}
            onChange={(value) => {
              setSelectedLocker(value ?? null);
              resetPage();
            }}
            className={styles.lockerSelect}
          />
        </div>
        <div>
          <span>事件：</span>
          <Select
            placeholder="請選擇事件"
            options={eventOptions}
            allowClear
            value={selectedEvent}
            onChange={(value) => {
              setSelectedEvent(value ?? null);
              resetPage();
            }}
            className={styles.eventSelect}
          />
        </div>
        <div>
          <span>時間：</span>
          <DatePicker.RangePicker
            placeholder={['起始時間', '結束時間']}
            allowClear
            value={queryTimes}
            onChange={(value) => {
              const [start, end] = value ?? [];
              if (start && end) {
                setQueryTimes([start, end]);
              } else {
                setQueryTimes(null);
              }
              resetPage();
            }}
            className={styles.timePicker}
          />
        </div>
      </div>
      <Card>
        <Table
          columns={columns}
          dataSource={dataSource}
          bordered
          pagination={{
            current: currentPage,
            total: history?.total,
            onChange: (page) => setCurrentPage(page),
            showSizeChanger: false,
          }}
          showSorterTooltip={false}
        />
      </Card>
    </div>
  );
};

export default LockerHistoryPage;
